import React from 'react';
import { motion } from 'framer-motion';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import whatsapp from '../../images/whatsapp-footer-cropped.svg';
import { SOCIAL_LINKS } from '../../constants';

const settings = {
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 3,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 5000,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true
			}
		}
	]
};

const mobileSettings = {
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 3,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 5000,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true
			}
		}
	]
};

const HiacePremio: React.FC = () => {
	const fleet = [
		{
			name: 'Dalam Kota Bandung',
			price: 'Rp 1.500.000',
			image: '/images/bandung.webp',
			include: 'Mobil, Supir, dan Bbm',
			exclude: 'Parkir dan Tol'
		},
		{
			name: 'Luar Kota',
			price: 'Rp 1.800.000',
			subtext: '(Karawang, Bekasi, Jakarta, Tanggerang)',
			image: '/images/jakarta.webp',
			include: 'Mobil, Supir, Tol,dan Bbm',
			exclude: 'Parkir'
		},
		{
			name: 'Pantai Pangadaran dan Santolo',
			price: 'Rp 1.750.000',
			minimumDays: '2',
			image: '/images/pangadaran.webp',
			include: 'Mobil, Supir, dan Bbm',
			exclude: 'Parkir dan Tol'
		},
		{
			name: 'Jawa Tengah',
			price: 'Rp 1.900.000',
			minimumDays: '3',
			image: '/images/borobudur.webp',
			include: 'Mobil, Supir, Tol, dan Bbm',
			exclude: 'Parkir'
		},
		{
			name: 'Jawa Timur',
			price: 'Rp 1.900.000',
			minimumDays: '5',
			image: '/images/bromo.webp',
			include: 'Mobil, Supir, Tol, dan Bbm',
			exclude: 'Parkir'
		},
		{
			name: 'Pangalengan dan Ciwidey',
			price: 'Rp 1.550.000',
			image: '/images/kawahputih.webp',
			include: 'Mobil, Supir, dan Bbm',
			exclude: 'Parkir dan Tol'
		}
	];

	const whatsAppLink = (location: string): string => {
		const insideLocation = ['Dalam Kota Bandung'];
		const phoneNumber: string = SOCIAL_LINKS.WHATSAPP.PHONE;
		const message: string = `Halo Ketaren Transport, apakah Hiace Premio untuk pemakaian ${insideLocation.includes(location) ? '' : 'ke'} ${location} masih tersedia? Terima kasih`;
		const encodedMessage: string = encodeURIComponent(message);
		const whatsappLink: string = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
		return whatsappLink;
	};

	return (
		<motion.section
			className="fleet"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: false, amount: 0.25 }}
			transition={{ duration: 0.5, ease: 'easeOut' }}
		>
			<motion.h2
				initial={{ opacity: 0, y: 20 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: false, amount: 0.25 }}
				transition={{ duration: 0.5, delay: 0.2 }}
			>
				Hiace Premio 14-seat Fleet
			</motion.h2>
			<motion.section
				className="carousel"
				initial={{ opacity: 0, scale: 0.95 }}
				whileInView={{ opacity: 1, scale: 1 }}
				viewport={{ once: false, amount: 0.25 }}
				transition={{ duration: 0.5, delay: 0.4 }}
			>
				<Slider {...settings}>
					{fleet.map((car, index) => (
						<motion.div
							key={index}
							className="carousel__slide"
							whileHover={{
								scale: 1.05,
								filter: 'brightness(1.1)',
								transition: { duration: 0.2 }
							}}
						>
							<div className="fleet-item">
								<h5>{car.name}</h5>
								<div className="fleet-item-price">
									<h3 className="fleet-item-price-text">{car.price}</h3>/Hari
								</div>
								{car.subtext && <p className="fleet-item-subtext">{car.subtext}</p>}
								{car.minimumDays && (
									<p className="fleet-item-subtext fleet-item-minimumDays">
										Min. {car.minimumDays} hari
									</p>
								)}
								<img
									className="fleet-item-image"
									src={car.image}
									alt={car.name}
									loading="lazy"
								/>
								<div className="fleet-item-desc-container">
									<h6 className="fleet-item-desc fleet-item-desc-include">
										Include
									</h6>
									<p className="fleet-item-desc-text">{car.include}</p>
								</div>
								<div className="fleet-item-desc-container">
									<h6 className="fleet-item-desc fleet-item-desc-exclude">
										Exclude
									</h6>
									<p className="fleet-item-desc-text">{car.exclude}</p>
								</div>
								<a
									href={whatsAppLink(car.name)}
									className="social-link-container"
									target="_blank"
									rel="noopener noreferrer"
								>
									<motion.div
										className="social-link social-link--whatsapp"
										whileHover={{
											scale: 1.05,
											y: -5
										}}
										transition={{
											type: 'spring',
											stiffness: 400,
											damping: 10
										}}
									>
										Whatsapp
										<img src={whatsapp} alt="Whatsapp" />
									</motion.div>
								</a>
							</div>
						</motion.div>
					))}
				</Slider>
			</motion.section>

			<motion.section
				className="mobile-carousel"
				initial={{ opacity: 0, scale: 0.95 }}
				whileInView={{ opacity: 1, scale: 1 }}
				viewport={{ once: false, amount: 0.25 }}
				transition={{ duration: 0.5, delay: 0.4 }}
			>
				<Slider {...mobileSettings}>
					{fleet.map((car, index) => (
						<motion.div
							key={index}
							className="carousel__slide"
							whileHover={{
								scale: 1.05,
								filter: 'brightness(1.1)',
								transition: { duration: 0.2 }
							}}
						>
							<div className="mobile-fleet-item">
								<h5>{car.name}</h5>
								<div className="fleet-item-price">
									<h3 className="fleet-item-price-text">{car.price}</h3>/Hari
								</div>
								{car.subtext && <p className="fleet-item-subtext">{car.subtext}</p>}
								{car.minimumDays && (
									<p className="fleet-item-subtext fleet-item-minimumDays">
										Min. {car.minimumDays} hari
									</p>
								)}
								<img
									className="fleet-item-image"
									src={car.image}
									alt={car.name}
									loading="lazy"
								/>
								<div className="fleet-item-desc-container">
									<h6 className="fleet-item-desc fleet-item-desc-include">
										Include
									</h6>
									<p className="fleet-item-desc-text">{car.include}</p>
								</div>
								<div className="fleet-item-desc-container">
									<h6 className="fleet-item-desc fleet-item-desc-exclude">
										Exclude
									</h6>
									<p className="fleet-item-desc-text">{car.exclude}</p>
								</div>
								<a
									href={whatsAppLink(car.name)}
									className="social-link-container"
									target="_blank"
									rel="noopener noreferrer"
								>
									<motion.div
										className="social-link social-link--whatsapp"
										whileHover={{
											scale: 1.05,
											y: -5
										}}
										transition={{
											type: 'spring',
											stiffness: 400,
											damping: 10
										}}
									>
										Whatsapp
										<img src={whatsapp} alt="Whatsapp" />
									</motion.div>
								</a>
							</div>
						</motion.div>
					))}
				</Slider>
			</motion.section>
		</motion.section>
	);
};

export default HiacePremio;
